import t from 'utils/t';

export const TXT_YOUR_ORDER = t('yourOrder', 'Замовлення');
export const TXT_EDIT = t('edit', 'Редагувати');
export const TXT_MENU = t('menu', 'Меню');
export const TXT_SEARCH = t('search', 'Пошук...');
export const TXT_CLEAR_ALL = t('clearAll', 'Видалити все');
export const TXT_SELECT = t('select', 'Обрати');
export const TXT_NO_RESULTS = t('noResults', 'Немає результатів за вашим пошуком');
export const TXT_NO_MENU = t('noMenu', 'На цей день меню ще немає');
export const TXT_ORDER = t('order', 'Замовити');
export const TXT_ITEM = t('item', '{{count}} позиція');
export const TXT_ITEM_ONE = t('item_one', '{{count}} позиція');
export const TXT_ITEM_FEW = t('item_few', '{{count}} позиції');
export const TXT_ITEM_MANY = t('item_many', '{{count}} позицій');
export const TXT_ITEM_OTHER = t('item_other', '{{count}} позицій');
export const TXT_PAY = t('pay', 'До сплати');
export const TXT_WEEK_TOTAL = t('weekTotal', 'Загалом за тиждень: {{total}} {{currency}}');
export const TXT_UAH = t('uah', 'грн');
export const TXT_UNIT_GRAM = t('unitGram', 'гр');
export const TXT_UNIT_PIECE = t('unitPiece', 'шт');
export const TXT_BACK = t('back', 'Назад');
export const TXT_NEXT = t('next', 'Вперед');
export const TXT_NAVIGATION_CURRENT = t('current', 'Сьогодні');
export const TXT_NOT_AVAILABLE = t('notAvailable', 'Не доступно');
export const TXT_LOADING = t('loading', 'Завантаження');
export const TXT_ERROR = t('error', 'Сталася помилка');
export const TXT_FORMATTED_PRICE = t('formattedPrice', '{{price}}');
export const TXT_CONFIRM_REMOVE_ORDER_TITLE = t('confirmRemoveOrderTitle', 'Ви хочете видалити замовлення');
export const TXT_NO = t('no', 'Ні');
export const TXT_YES = t('yes', 'Так');
export const TXT_DINNER = t('dinner', 'Обід');
export const TXT_BREAKFAST = t('breakfast', 'Сніданок');
export const TXT_ORDER_SUCCESSFULLY_CREATED = t('orderSuccessfullyCreated', 'Замовлення успішно створено');
export const TXT_ORDER_SUCCESSFULLY_UPDATED = t('orderSuccessfullyUpdated', 'Замовлення успішно оновлено');
export const TXT_ORDER_SUCCESSFULLY_DELETED = t('orderSuccessfullyDeleted', 'Замовлення успішно видалено');
export const TXT_ERROR_INVALID_REQUEST_PARAMS = t('error.invalidRequestParams', 'Невалідні параметри запиту');
export const TXT_ERROR_NOT_FOUND = t('error.notFound', 'Ресурс не знайдено');
export const TXT_ERROR_NAME_NOT_FOUND = t('error.nameNotFound', 'Найменування не знайдено');
export const TXT_ERROR_UNAUTHORIZED = t('error.unauthorized', 'Помилка авторизації');
export const TXT_ERROR_INTEGRATION_ERROR = t('error.integrationError', 'Помилка під час запису');
export const TXT_ERROR_SERVER_ERROR = t('error.serverError', 'Помилка сервера');
export const TXT_ERROR_NOT_IMPLEMENTED = t('error.notImplemented', 'Функція не впроваджена');
export const TXT_ERROR_UNPROCESSABLE = t('error.unprocessable', 'Запит неможливо обробити');
export const TXT_ERROR_FORBIDDEN = t('error.forbidden', 'В доступі заборонено');
export const TXT_ERROR_ALREADY_EXISTS = t('error.alreadyExists', 'Замовлення вже існує');
export const TXT_ERROR_BAD_REQUEST = t('error.badRequest', 'Невалідні або відсутні параметри запиту');
export const TXT_ERROR_CLOSED_FOR_WRITE = t('error.closedForWrite', 'Меню закрите для запису');
export const TXT_ERROR_IMAGE_NOT_FOUND = t('error.imageNotFound', 'Зображення не знайдено');
export const TXT_ERROR_READ_IMAGE_BYTES_ERROR = t('error.readImageBytesError', 'Помилка зчитування зображення');
export const TXT_ERROR_COMPANY_NOT_FOUND = t('error.companyNotFound', 'Компанію не знайдено');
export const TXT_ERROR_MENU_NOT_FOUND = t('error.menuNotFound', 'Меню не знайдено');
export const TXT_ERROR_MENU_ITEM_NOT_FOUND = t('error.menuItemNotFound', 'Страву не знайдено');
export const TXT_ERROR_DEBTOR_USER = t('error.debtorUser', 'Сплатіть борг');
export const TXT_ERROR_CATEGORY_NOT_FOUND = t('error.categoryNotFound', 'Категорію не знайдено');
export const TXT_ERROR_PRODUCT_NOT_FOUND = t('error.productNotFound', 'Страву не знайдено');
export const TXT_ORDER_COMMENT = t('orderComment', 'Коментар до замовлення');
export const TXT_ORDER_COMMENT_MAX_SIZE = t('orderCommentMaxSize', '{{count}}/{{maxCount}} символів');
export const TXT_ERROR_ORDER_COMMENT_MAX_SIZE = t('error.orderCommentMaxSize', 'Максимальна довжина коментаря {{count}} символів');
